import * as React from 'react';
import GroupContactsList from './GroupContactsList/GroupContactsList';
import GroupsList from './GroupsList/GroupsList';

interface Props {
    groupsList: number | null;
}

export default function ContactGroups({ groupsList }: Props) {
    return (
        <React.Fragment>
            {groupsList === null && <GroupsList />}
            {groupsList !== null && <GroupContactsList showListId={groupsList} />}
        </React.Fragment>
    );
}
